import React from 'react'
import {useSelector} from 'react-redux'
import dictionary from '../../../dictionary'
import trackEvent from '../../../utils/track-event'
import {filtersSelector} from '../selectors'

export default function NoFindProducts() {
    const isCustomStore = useSelector((state) => state.isCustomStore)
    const filters = useSelector((state) =>
        filtersSelector(state, isCustomStore),
    )

    return (
        <div className="no-find-products">
            <h3>{dictionary.store.Didnt_find_what_you_were_looking_for}?</h3>
            <a
                href={filters.cod}
                onClick={() =>
                    trackEvent({
                        category: 'store button',
                        action: 'no_products_create_design',
                    })
                }
                className="b-btn b-btn_info"
            >
                {dictionary.store.Create_own_design}
            </a>
        </div>
    )
}
